import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Menu, X, Rocket, Zap } from 'lucide-react';
export function Navigation() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 10);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Probeer',
    href: '#probeer'
  }, {
    name: 'Verschil',
    href: '#anders'
  }, {
    name: 'Kwaliteit',
    href: '#kwaliteit'
  }, {
    name: 'Vraagtypes',
    href: '#vraagtypes'
  }, {
    name: 'FAQ',
    href: '#faq'
  }];
  return <header className="fixed top-0 left-0 right-0 z-50 flex flex-col" data-id="element-512">
      {/* RC Banner */}
      <div className="bg-slate-900 text-white px-4 py-2 text-[11px] font-bold text-center flex items-center justify-center gap-2 tracking-wide" data-id="element-513">
        <Rocket className="w-3.5 h-3.5 text-orange-400" data-id="element-514" />
        <span data-id="element-515">
          Release Candidate · vroege toegang open ·{' '}
          <a href="#aanmelden" className="underline underline-offset-2 hover:text-orange-200" data-id="element-516">
            meld je aan
          </a>
        </span>
      </div>

      {/* Main pill nav */}
      <nav className={`transition-all duration-300 ${isScrolled ? 'py-2' : 'py-3'}`} data-id="element-517">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-518">
          <motion.div layout transition={{
          duration: 0.3
        }} className={`flex justify-between items-center transition-all duration-300 ${isScrolled ? 'bg-white/85 backdrop-blur-xl shadow-lg shadow-slate-900/5 border border-white rounded-2xl px-4 py-2.5' : 'bg-transparent px-0 py-2'}`} data-id="element-519">
            {/* Logo */}
            <a href="#" className="flex items-center gap-2.5 group shrink-0" data-id="element-520">
              <motion.div whileHover={{
              rotate: [0, -6, 6, 0],
              scale: 1.06
            }} transition={{
              duration: 0.5
            }} className="w-9 h-9 bg-gradient-to-br from-orange-400 to-orange-600 rounded-xl flex items-center justify-center text-white font-black text-sm shadow-md shadow-orange-500/30" data-id="element-521">
                md
              </motion.div>
              <div className="inline-flex items-baseline gap-1.5 select-none text-xl" data-id="element-522">
                <span className="font-extrabold tracking-tight text-slate-800" data-id="element-523">
                  Meester
                </span>
                <span className="font-extrabold italic tracking-tight text-orange-500" data-id="element-524">
                  djay
                </span>
              </div>
            </a>

            {/* Desktop Links */}
            <div className="hidden md:flex items-center gap-1" data-id="element-525">
              {navLinks.map(link => <a key={link.name} href={link.href} className="relative text-sm font-bold text-slate-600 hover:text-slate-900 transition-colors px-3 py-2 rounded-lg hover:bg-slate-100/60" data-id="element-526">
                  {link.name}
                </a>)}
            </div>

            {/* CTA */}
            <div className="hidden md:flex" data-id="element-527">
              <motion.a href="#aanmelden" whileHover={{
              y: -2
            }} whileTap={{
              y: 1
            }} className="inline-flex items-center gap-1.5 bg-slate-900 text-white shadow-[0_4px_0_0_rgb(15,23,42)] hover:bg-slate-800 active:shadow-none rounded-xl font-bold px-4 py-2.5 transition-colors text-sm" data-id="element-528">
                <Zap className="w-3.5 h-3.5 text-orange-400" strokeWidth={3} data-id="element-529" />
                Word tester
              </motion.a>
            </div>

            {/* Mobile Menu Button */}
            <button className="md:hidden p-2 text-slate-600 hover:text-orange-500 transition-colors" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Toggle menu" data-id="element-530">
              {isMobileMenuOpen ? <X className="w-5 h-5" data-id="element-531" /> : <Menu className="w-5 h-5" data-id="element-532" />}
            </button>
          </motion.div>
        </div>
      </nav>

      {/* Mobile Menu */}
      <AnimatePresence data-id="element-533">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="md:hidden bg-[#FFF9F2] border-b border-orange-100 shadow-lg overflow-hidden" data-id="element-534">
            <div className="px-4 pt-2 pb-6 flex flex-col gap-2" data-id="element-535">
              {navLinks.map(link => <a key={link.name} href={link.href} onClick={() => setIsMobileMenuOpen(false)} className="text-sm font-bold text-slate-600 hover:text-orange-500 py-3 border-b border-orange-50" data-id="element-536">
                  {link.name}
                </a>)}
              <a href="#aanmelden" onClick={() => setIsMobileMenuOpen(false)} className="bg-slate-900 text-white shadow-[0_4px_0_0_rgb(15,23,42)] active:translate-y-[2px] active:shadow-none rounded-xl font-bold px-6 py-3 transition-all text-sm text-center mt-4" data-id="element-537">
                Word tester
              </a>
            </div>
          </motion.div>}
      </AnimatePresence>
    </header>;
}